import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const contactAPI = createApi({
  reducerPath: "contactAPI",
  baseQuery: fetchBaseQuery({ baseUrl: BaseUrl, 
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
   }),
  endpoints: (builder) => ({
    getContactContentData: builder.query({
      query: () => `contact-content/list`,
    }),
    submitContactForm: builder.mutation({
      query: (formData) => ({
        url: "contact",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useGetContactContentDataQuery, useSubmitContactFormMutation } =
  contactAPI;
